import EmployeeTerminateInterface, {
  EmployeeTerminatePreloadDataInterface,
} from '../interfaces/EmployeeTerminateInterface';
import http from '../helpers/http';

const EmployeeTerminate = (token: string) => {
  const headers = {
    'x-access-token': token,
  };

  return {
    create: async (body: Partial<EmployeeTerminateInterface>) => {
      const result = await http.post(`/employee-terminate`, body, { headers });
      return result.data;
    },
    listBySchool: async (schoolId: string) => {
      const result = await http.get(`/employee-terminate/by-school/${schoolId}`, {
        headers,
      });
      return result.data;
    },
    revoke: async (employeeId: string) => {
      const result = await http.patch(
        `/employee-terminate/${employeeId}/revoke`,
        {},
        {
          headers,
        },
      );
      return result.data;
    },
    getPreloadData: async (employeeId: string): Promise<EmployeeTerminatePreloadDataInterface> => {
      const result = await http.get(`/employee-terminate/${employeeId}/preload-data`, {
        headers,
      });
      return result.data.data;
    },
    listPending: async (schoolId: string, status?: string, includeHidden?: boolean) => {
      const params: Record<string, string> = {};
      if (status) params.status = status;
      if (includeHidden) params.includeHidden = 'true';
      const result = await http.get(`/employee-terminate/by-school/${schoolId}/pending`, {
        headers,
        params,
      });
      return result.data.data || [];
    },
    approve: async (id: string) => {
      const result = await http.patch(`/employee-terminate/${id}/approve`, {}, { headers });
      return result.data;
    },
    finalize: async (id: string, formData: FormData) => {
      const result = await http.patch(`/employee-terminate/${id}/finalize`, formData, {
        headers: {
          'x-access-token': token,
        },
      });
      return result.data;
    },
    getTemplateDocument: async (id: string): Promise<Blob> => {
      const result = await http.get(`/employee-terminate/${id}/template-document`, {
        headers,
        responseType: 'blob',
      });
      return result.data;
    },
    deny: async (id: string, reason: string) => {
      const result = await http.patch(
        `/employee-terminate/${id}/deny`,
        { reason },
        {
          headers,
        },
      );
      return result.data;
    },
    hide: async (id: string) => {
      const result = await http.patch(`/employee-terminate/${id}/hide`, {}, { headers });
      return result.data;
    },
  };
};

export default EmployeeTerminate;
